import {RequestState} from "@pg-mono/request-state";

import {Country} from "../../../region/types/Country";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {getCountryId} from "./sub_type/get_fetch_offer_list_subfilter_query";
import {isPromotionsListingQuery} from "./map_offer_list_promotions_query_param";

export const shouldShowOfferListingPromotionTabs = ({
    latestQuery,
    routeQuery,
    listingContextPromotionalOffersCount,
    listingContextPromotionalOffersCountRequestState
}: {
    latestQuery: IOfferListLatestQuery;
    routeQuery: Record<string, string | string[] | null | boolean | undefined>;
    listingContextPromotionalOffersCount: number | null;
    listingContextPromotionalOffersCountRequestState: RequestState;
}): boolean => {
    const countryId = getCountryId(latestQuery.country);

    if (countryId && countryId !== Country.POLAND) {
        return false;
    }

    if (isPromotionsListingQuery(routeQuery)) {
        return true;
    }

    const hasPromotionalOffersInContext = listingContextPromotionalOffersCount != null && listingContextPromotionalOffersCount > 0;

    const promotionalOffersCountReady =
        listingContextPromotionalOffersCountRequestState === RequestState.Success || listingContextPromotionalOffersCountRequestState === RequestState.Waiting;

    return hasPromotionalOffersInContext && promotionalOffersCountReady;
};
import {RequestState} from "@pg-mono/request-state";

import {Country} from "../../../region/types/Country";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {getCountryId} from "./sub_type/get_fetch_offer_list_subfilter_query";
import {isPromotionsListingQuery} from "./map_offer_list_promotions_query_param";

export const shouldShowOfferListingPromotionTabs = ({
    latestQuery,
    routeQuery,
    listingContextPromotionalOffersCount,
    listingContextPromotionalOffersCountRequestState
}: {
    latestQuery: IOfferListLatestQuery;
    routeQuery: Record<string, string | string[] | null | boolean | undefined>;
    listingContextPromotionalOffersCount: number | null;
    listingContextPromotionalOffersCountRequestState: RequestState;
}): boolean => {
    const countryId = getCountryId(latestQuery.country);

    if (countryId && countryId !== Country.POLAND) {
        return false;
    }

    if (isPromotionsListingQuery(routeQuery)) {
        return true;
    }

    const hasPromotionalOffersInContext = listingContextPromotionalOffersCount != null && listingContextPromotionalOffersCount > 0;

    const promotionalOffersCountReady =
        listingContextPromotionalOffersCountRequestState === RequestState.Success || listingContextPromotionalOffersCountRequestState === RequestState.Waiting;

    return hasPromotionalOffersInContext && promotionalOffersCountReady;
};
